import { showGlobalPreloader, hideGlobalPreloader } from "./utils.js";

document.addEventListener("DOMContentLoaded", function () {
  const mapContainer = document.getElementById("world-map");
  if (!mapContainer || typeof L === "undefined") {
    hideGlobalPreloader();
    return;
  }

  var map = L.map("world-map", {
    scrollWheelZoom: false,
    worldCopyJump: true,
  }).setView([20.5937, 78.9629], 3);

  L.tileLayer(
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    {
      attribution: "Tiles &copy; Esri",
      className: "night-tiles",
      maxZoom: 18,
    },
  ).addTo(map);

  L.tileLayer(
    "https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
    {
      attribution: "",
      className: "map-labels",
      maxZoom: 18,
    },
  ).addTo(map);

  const token = localStorage.getItem("access_token");
  const headers = { "X-Background-Request": "true" };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  showGlobalPreloader("Loading global network...");
  fetch("/api/Organizations/locations", { headers })
    .then((response) => {
      if (!response.ok) return [];
      return response.json();
    })
    .then((data) => (Array.isArray(data) ? data : []))
    .catch(() => [])
    .then((locations) => {
      if (!Array.isArray(locations) || locations.length === 0) {
        const LUKAIN_HQ_FALLBACK = [
          {
            name: "LukaIN Headquarters (Khatima, India)",
            latitude: 28.9125,
            longitude: 79.9717,
            is_hq: true,
          },
        ];
        locations = LUKAIN_HQ_FALLBACK.slice(0, 1);
      }

      const markerGroup = L.layerGroup().addTo(map);
      locations.forEach((location) => {
        if (
          location &&
          typeof location.latitude === "number" &&
          typeof location.longitude === "number" &&
          (location.latitude !== 0 || location.longitude !== 0) &&
          location.latitude >= -90 &&
          location.latitude <= 90 &&
          location.longitude >= -180 &&
          location.longitude <= 180
        ) {
          const isHq = !!location.is_hq;
          const beaconColor = isHq ? "#ffd166" : "#066fff";
          const ringColor = isHq ? "rgba(255, 209, 102, 0.35)" : "rgba(6, 111, 255, 0.35)";

          var customIcon = L.divIcon({
            className: "beacon-marker",
            html: `<div class="beacon" style="background:${beaconColor}"></div>` +
                  `<div class="beacon-ring" style="border-color:${ringColor}"></div>`,
            iconSize: [20, 20],
            iconAnchor: [10, 10],
            popupAnchor: [0, -10],
          });

          var marker = L.marker([location.latitude, location.longitude], {
            icon: customIcon,
            title: location.name || "",
          });
          marker.bindTooltip(location.name || "Site", {
            permanent: false,
            direction: "top",
            offset: [0, -15],
            className: "custom-tooltip",
          });
          markerGroup.addLayer(marker);
        }
      });

      const markerLayers = markerGroup.getLayers();
      if (markerLayers.length > 0) {
        try {
          map.fitBounds(markerGroup.getBounds().pad(0.3), {
            maxZoom: 4,
            duration: 0.5,
          });
        } catch {
          // ignore fitBounds errors on single point or bad bounds
        }
      }

      setTimeout(() => {
        map.invalidateSize();
      }, 250);
    })
    .finally(() => {
      hideGlobalPreloader();
    });
});
